import { useTranslation } from "react-i18next";
import { Dialog } from "~/foundation/components/Dialog";
import { Kbd } from "~/foundation/components/Kbd";

const SHORTCUTS: Array<{ keys: string[]; label: string }> = [
  { keys: ["Meta", "k"], label: "Open the command bar" },
  { keys: ["Meta", "."], label: "Toggle sidebar" },
  { keys: ["Shift", "d"], label: "Dark theme" },
  { keys: ["Shift", "l"], label: "Light theme" },
  { keys: ["Shift", "s"], label: "System theme" },
  { keys: ["?"], label: "Keyboard shortcuts" },
];

export function KeyboardShortcutsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("Keyboard shortcuts")}
      closeLabel={t("Close")}
      size="md"
    >
      <ul className="flex flex-col">
        {SHORTCUTS.map((shortcut) => (
          <li
            key={shortcut.label}
            className="flex items-center justify-between gap-4 border-b border-divider py-2 last:border-b-0"
          >
            <span className="text-body text-text">{t(shortcut.label)}</span>
            <Kbd keys={shortcut.keys} />
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
